import React, { useEffect, useState } from 'react'
// React Router
import { useNavigate } from 'react-router-dom'
// Ant Design
import { Flex, message, Empty } from 'antd'
// Layout
import { Sidebar } from '../Layout/Sidebar'
// Fragments
import { Header } from '../Fragments/List/Header'
import { ContentList } from '../Fragments/List/ContentList'
import { ContentReport } from '../Fragments/List/ContentReport'
// i18
import { useTranslation } from 'react-i18next'
// Axios
import axios from 'axios'
// Config
import config from '../config'

export const List = () => {

    const [messageApi, contextHolder] = message.useMessage()
    const navigate = useNavigate()
    const { t } = useTranslation(["translation"])

    const [select, setSelect] = useState({})
    const [reports, setReports] = useState([])
    const [loading, setLoading] = useState(false)
    const [changeGraph, setChangeGraph] = useState(false)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)

    const apiReports = async() => {

        var pageNew = 0
        if(page <= 0) {
            pageNew = 0
        }
        else {
            pageNew = (page*10)-10
        }

        setLoading(true)
        try {
            const res = await axios.get(`${config.urlApi}/private/report?skip=${pageNew}`, {
                withCredentials: true,
            })
            if(res.status === 200) {
                setReports(res.data.data)
                setTotal(res.data.num_items)
                setLoading(false)
            }
        }
        catch (error) {
            setLoading(false)
            if (error.status === 401) {
                navigate("/")
            }
            else if(error.status === 404) {
                return
            }
            else {
                messageApi.error(t("error_list_report"))
            }
        }
    }

    useEffect(() => {
        apiReports()

        const alert = localStorage.getItem("alertReport")
        if (alert) {
            messageApi.success(t("report_create_success"))
            localStorage.removeItem("alertReport")
        }
    }, [page])


    return (
        <Flex>
            <Sidebar />

            <Flex vertical style={{ width: "calc(100% - 250px)", height: "100vh", padding: "0 15px" }}>
                <Header t={t} />
                {(reports.length===0 && !loading)
                    ?
                    <Flex justify="center" style={{ width: "100%", marginTop: "10px" }}>
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("empty_list_report")} />
                    </Flex>
                    :
                    <Flex>
                        <ContentList t={t} select={select} setSelect={setSelect} reports={reports} loading={loading} setChangeGraph={setChangeGraph} page={page} setPage={setPage} total={total} />
                        <ContentReport t={t} select={select} setSelect={setSelect} apiReports={apiReports} changeGraph={changeGraph} setChangeGraph={setChangeGraph} />
                    </Flex>
                }
            </Flex>

            {contextHolder}
        </Flex>
    )
}
